import * as React from 'react'
import { RecommendationInstance } from '../../../../../../models/Recommendation'
import { breakpoint, styled } from '../../../../../../shared/styled-components'
import { JawRecommendation } from './JawRecommendation'

interface IProps {
  recommendations: RecommendationInstance[]
}

export class JawRecommendationsList extends React.Component<IProps> {
  render () {
    const { recommendations } = this.props
    return (<Container>
      {recommendations
        .filter(r => r.recommendationType === 'crown')
        .map(recommendation =>
          <JawRecommendation
            recommendation={recommendation}
            key={recommendation.recommendationType + recommendation.count} />
      )}
    </Container>)
  }
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  ${breakpoint('tablet')`
    flex-direction: row;  
  `}
`
